module.exports = __webpack_public_path__ + "img/img-13.8277fb95.png";